export function joinAndFilter(...args: (string | undefined | boolean)[]): string {
    return args.filter(a => a).join('\n');
}
